import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import useMoney from '../../../../../../../hooks/useMoney';
import { formatPercentNumberString } from '../../../../../../../utils/formatters';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { GetOrderItemsStatus } from '../../../../../products/orderProducts.types';
import { buildIncomeStatusRows } from '../orderSummaryTotals.utils';

interface OrderSummaryIncomeStatusTooltipProps {
  incomeStatus: GetOrderItemsStatus;
  totalValue: number;
}

const OrderSummaryIncomeStatusTooltip = ({
  incomeStatus,
  totalValue,
}: OrderSummaryIncomeStatusTooltipProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  const rows = buildIncomeStatusRows(incomeStatus, totalValue);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto',
        alignItems: 'baseline',
        columnGap: 1.5,
        rowGap: 0.5,
      }}
    >
      {rows.map((row) => (
        <Box key={row.label} sx={{ display: 'contents' }}>
          <Typography noWrap variant="body2" color="inherit">
            {translate(row.label)}
          </Typography>
          <Typography noWrap variant="body2" color="inherit">
            {row.quantity}
          </Typography>
          <Typography noWrap variant="body2" color="inherit">
            {formatMoney(row.value)}
          </Typography>
          <Typography noWrap variant="body2" color="inherit">
            {formatPercentNumberString(row.percent)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default OrderSummaryIncomeStatusTooltip;
